import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  listNews: (
    page: number,
    filters?: any[],
    sorters?: any[],
    limit?: number,
  ) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query (
          $page: Int!
          $filters: [Filter]
          $sorters: [Sorter]
          $limit: Int
        ) {
          listNews (
            page: $page
            filters: $filters
            sorters: $sorters
            limit: $limit
          ) {
            items {
              alias
              image {
                url
              }
              title {
                current
              }
              publicationTime
              visibleOnFrontPage
              shortText {
                current
              }
              type
            }
            pagination {
              pages
            }
          }
        }
      `,

      variables: {
        page,
        filters,
        sorters,
        limit,
      },
    }),
  ),

  getNewsItem: (alias: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query ($alias: String!) {
          listNews(limit: 1, filters: [{ name: "alias", value: $alias }]) {
            items {
              alias
              image {
                url
              }
              title {
                current
              }
              publicationTime
              shortText {
                current
              }
              text {
                current
              }
            }
          }
        }
      `,

      variables: {
        alias,
      },
    }),
  ),
})
